// extracted by mini-css-extract-plugin
export default {"strip":"StatsStrip_strip__NCtOm","stat":"StatsStrip_stat__Z02-W","value":"StatsStrip_value__tmNVY","label":"StatsStrip_label__xrOAC"};